import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-select',
  templateUrl: './form-select.component.html',
  imports: [ReactiveFormsModule, FormsModule, FormFieldErrorComponent],
})
export class FormSelectComponent extends FieldBaseComponent {
  onChange($event: any) {
    if (this.config.onSelectChange) {
      this.config.onSelectChange($event.target.value);
    }
  }
}
